import { useNavigate } from "react-router-dom";
import { useContext, useCallback } from "react";
import { AuthContext } from "../context/AuthContext";

export function useAuthErrorHandler() {
  const navigate = useNavigate();
  const { logout } = useContext(AuthContext);

  return useCallback((response) => {
    if (response.status === 401) {
      logout();
      setTimeout(() => navigate("/login", { replace: true }), 0);
      return true;
    }
    return false;
  }, [logout, navigate]);
}